// extracted by mini-css-extract-plugin
export default {"container":"styles_container__T6Lrf","warning":"styles_warning__JmK52","email":"styles_email__U9IE8"};